var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "separator" }, [
    _c("i"),
    _c("small", [_vm._v(_vm._s(_vm.label))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }